import { F } from "./primitives";

/* v2.87 · Transformer NEC 450.3(B) inputs — extracted from Calculators.jsx.
   Includes v2.83 supervised-location exception + both-sides sizing toggle. */
export function TransformerInputs({ form, patchForm }) {
  return (
    <div className="mt-4 p-3 border border-[#00E5FF]/20 bg-[#00E5FF]/5"
         data-testid="cond-transformer-fields">
      <div className="label-tag mb-2">// transformer · NEC 450.3(B)</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <F label="Transformer kVA">
          <input type="number" value={form.transformer_kva}
            onChange={(e) => patchForm({ transformer_kva: Number(e.target.value) })}
            className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
            data-testid="cond-txfmr-kva" />
        </F>
        <F label="Secondary V">
          <input type="number" value={form.transformer_secondary_voltage}
            onChange={(e) => patchForm({ transformer_secondary_voltage: Number(e.target.value) })}
            className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
            data-testid="cond-txfmr-sec-v" />
        </F>
        <F label="Winding side (single-cable mode)">
          <select value={form.transformer_side}
            onChange={(e) => patchForm({ transformer_side: e.target.value })}
            className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
            data-testid="cond-txfmr-side"
            disabled={form.transformer_size_both_sides}
            title="Ignored when 'Size both sides' is on — both cables are computed in one shot.">
            <option value="primary">Primary</option>
            <option value="secondary">Secondary</option>
          </select>
        </F>
        <label className="flex items-center gap-2 mt-6"
               title="NEC 450.3(B): when secondary protection is provided, primary OCPD max jumps to 250 % of primary FLC. Otherwise primary is limited to 125 % (or 167 %/300 % for very small FLCs).">
          <input type="checkbox" checked={form.transformer_has_secondary_protection}
            onChange={(e) => patchForm({ transformer_has_secondary_protection: e.target.checked })}
            className="accent-[#00E5FF]"
            data-testid="cond-txfmr-sec-prot" />
          <span className="text-sm">Secondary OCPD provided</span>
        </label>
        <label className="flex items-center gap-2"
               title="NEC 450.3(B) 'Supervised locations only' exception — primary-only ≥ 9 A jumps from 125 % → 250 %, and primary-and-secondary ≥ 9 A secondary jumps 125 % → 250 %.">
          <input type="checkbox" checked={form.transformer_supervised}
            onChange={(e) => patchForm({ transformer_supervised: e.target.checked })}
            className="accent-[#FFCC00]"
            data-testid="cond-txfmr-supervised" />
          <span className="text-sm">Supervised location (exception)</span>
        </label>
        <label className="flex items-center gap-2"
               title="Size PRIMARY and SECONDARY cables + OCPDs in one calc. Uses the primary/secondary lengths below.">
          <input type="checkbox" checked={form.transformer_size_both_sides}
            onChange={(e) => patchForm({ transformer_size_both_sides: e.target.checked })}
            className="accent-[#00E5FF]"
            data-testid="cond-txfmr-both-sides" />
          <span className="text-sm font-bold">Size both sides in one shot</span>
        </label>
        {form.transformer_size_both_sides && (
          <>
            <F label="Primary cable length (ft)">
              <input type="number" value={form.transformer_primary_length_ft}
                onChange={(e) => patchForm({ transformer_primary_length_ft: Number(e.target.value) })}
                className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
                data-testid="cond-txfmr-pri-len" />
            </F>
            <F label="Secondary cable length (ft)">
              <input type="number" value={form.transformer_secondary_length_ft}
                onChange={(e) => patchForm({ transformer_secondary_length_ft: Number(e.target.value) })}
                className="w-full bg-black/40 border border-white/10 px-2 py-2 text-sm font-mono focus:border-[#00E5FF] outline-none"
                data-testid="cond-txfmr-sec-len" />
            </F>
          </>
        )}
      </div>
    </div>
  );
}
